import React, { useState, useEffect } from 'react';

const ProgressBar = ({ label, value, max = 100 }) => {
    const [width, setWidth] = useState(0);
    const target = (value / max) * 100;

    useEffect(() => {
        const timer = setTimeout(() => setWidth(target), 700);
        return () => clearTimeout(timer);
    }, [target]);

    return (
        <div className="clinic-dashboard-progress">
            <div className="clinic-dashboard-progress-header">
                <span className="clinic-dashboard-progress-label">{label}</span>
                <span className="clinic-dashboard-progress-value">{value}%</span>
            </div>
            <div className="clinic-dashboard-progress-track">
                <div
                    className="clinic-dashboard-progress-fill"
                    style={{ width: `${width}%`, transition: 'width 1.2s cubic-bezier(0.4, 0, 0.2, 1)' }}
                />
            </div>
        </div>
    );
};

export default ProgressBar;
